var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0862 15.7336L18.769 13.4155C18.2707 12.9162 17.5942 12.6357 16.8888 12.6357C16.1835 12.6357 15.507 12.9162 15.0087 13.4155L14.5362 13.888C12.2074 11.9367 10.0562 9.7827 8.1081 7.4514L8.5806 6.9788C9.6165 5.9398 9.6165 4.2585 8.5806 3.2195L6.2586 0.904158C5.2056 -0.101842 3.54758 -0.101842 2.49454 0.904158L1.2282 2.17618C-0.0260291 3.43944 -0.223209 5.4088 0.755681 6.8957C4.5312 12.5846 9.4065 17.4609 15.0947 21.2375C16.5858 22.2069 18.5502 22.0105 19.8199 20.765L21.0909 19.493C21.5901 18.995 21.8706 18.3189 21.8706 17.6138C21.8706 16.9087 21.5901 16.2326 21.0909 15.7346L21.0862 15.7336Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.e9adc741.svg";
export { ForwardRef as ReactComponent };